import Vue from 'vue';
import axios from 'axios';

import store from '@/store';
import i18n from '@/i18n';

function getAuthorizationHeader() {
  const { token_type, access_token } = store.state.auth.credentials;
  return token_type && access_token ? `${token_type} ${access_token}` : null;
}

/**
 * Create a global API instance with common defaults
 */
const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Intercept all API requests
 */
api.interceptors.request.use(config => {
  // Authenticate requests when user is logged in
  const auth = getAuthorizationHeader();
  if (auth) {
    config.headers.common['Authorization'] = getAuthorizationHeader();
  }
  return config;
});

/**
 * Intercept all API responses
 */
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // An error 403 means the user token has expired
      if (error.response.status === 403) {
        // Try to refresh the token
        // If it fails, the user will be automatically logged out
        return store.dispatch('auth/refreshTokenOrLogout').then(
          () => {
            // Token refresh succeeded
            // Let's redo the failed request with the new token
            error.config.headers.Authorization = getAuthorizationHeader();
            return axios.request(error.config);
          },
          () => {
            // Token refresh failed
            // Let's pass down the original request error
            return Promise.reject(error);
          }
        );
      }

      return Promise.reject(error);
    } else if (error.request) {
      Vue.notify({
        type: 'error',
        title: i18n.t('common.error'),
        text: i18n.t('network.error'),
        duration: -1,
      });
    }

    return Promise.reject(error);
  }
);

export default api;
